const SUFFIX = "api/v1";
export const API_URL = `${process.env.API_URL}/${SUFFIX}`;
export default API_URL;
